export const locales = ['fr', 'en'] as const

export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = 'fr'
export const localeCookieName = 'cocoon_locale'

export const isLocale = (value: string): value is Locale =>
	locales.includes(value as Locale)

export const getLocalizedPath = (pathname: string, locale: Locale) => {
	const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`

	if (locale === defaultLocale) {
		return normalizedPath
	}

	if (
		normalizedPath === `/${locale}` ||
		normalizedPath.startsWith(`/${locale}/`)
	) {
		return normalizedPath
	}

	return normalizedPath === '/' ? `/${locale}` : `/${locale}${normalizedPath}`
}

export const stripLocaleFromPath = (pathname: string) => {
	for (const locale of locales) {
		if (locale === defaultLocale) continue

		if (pathname === `/${locale}`) {
			return '/'
		}

		if (pathname.startsWith(`/${locale}/`)) {
			return pathname.slice(locale.length + 1)
		}
	}

	return pathname
}

export const getLocaleFromPath = (pathname: string): Locale => {
	for (const locale of locales) {
		if (locale === defaultLocale) continue

		if (pathname === `/${locale}` || pathname.startsWith(`/${locale}/`)) {
			return locale
		}
	}

	return defaultLocale
}
